export const routes = {
  home: '/',
  bridge: '/bridge',
  profile: '/profile',
  profileTab: '/profile/:tab'
}
